// extracted by mini-css-extract-plugin
export default {"forbidden":"Forbidden_forbidden__L3W05","lock":"Forbidden_lock__q6+cQ","dip":"Forbidden_dip__Zi-7+","spin":"Forbidden_spin__c3CP2"};